import { useRef, useEffect } from 'react';

function TicketCancelLogic({
  statement,
  departureChosenSeats,
  returnChosenSeats,
  bookingData,
  ridesCarriagesInfo,
  cancelStatement,
  cancelRef,
}) {
  // Define refs
  const statementRef = useRef(statement);
  const departureChosenSeatsRef = useRef(departureChosenSeats);
  const returnChosenSeatsRef = useRef(returnChosenSeats);
  const bookingDataRef = useRef(bookingData);
  const ridesCarriagesInfoRef = useRef(ridesCarriagesInfo);

  // Your cancel function
  const cancelCurrentStatement = () => {
    if (cancelRef.current === 'cancel') {
      // Use refs to access the most current values
      const statementId = statementRef.current?.id
        || departureChosenSeatsRef.current?.[0]?.statement_id
        || returnChosenSeatsRef.current?.[0]?.statement_id
        || bookingDataRef.current?.id;

      const statementGuid = statementRef.current?.statementGuid
        || departureChosenSeatsRef.current?.[0]?.guid
        || returnChosenSeatsRef.current?.[0]?.guid
        || ridesCarriagesInfoRef.current?.statement?.statementGuid
        || bookingDataRef.current?.guid;

      if (statementId && statementGuid) {
        cancelStatement(statementId, statementGuid);
      }
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-param-reassign
    cancelRef.current = 'cancel';
    window.addEventListener('beforeunload', cancelCurrentStatement);
    window.addEventListener('onunload', cancelCurrentStatement);

    // Cleanup function will now use the most current values
    return () => {
      cancelCurrentStatement();
      window.removeEventListener('beforeunload', cancelCurrentStatement);
      window.removeEventListener('onunload', cancelCurrentStatement);
    };
  }, []);

  // Update refs when state changes
  useEffect(() => {
    statementRef.current = statement;
  }, [statement]);

  useEffect(() => {
    departureChosenSeatsRef.current = departureChosenSeats;
  }, [departureChosenSeats]);

  useEffect(() => {
    returnChosenSeatsRef.current = returnChosenSeats;
  }, [returnChosenSeats]);

  useEffect(() => {
    bookingDataRef.current = bookingData;
  }, [bookingData]);

  useEffect(() => {
    ridesCarriagesInfoRef.current = ridesCarriagesInfo;
  }, [ridesCarriagesInfo]);

  return (
    <div className="hidden">
      beka cancel statement logic
    </div>
  );
}

export default TicketCancelLogic;
